module.exports = __webpack_public_path__ + "img/login_nft.315ae7a8.svg";